import { useTranslation } from '@mc/i18n'
import Amazon from './Amazon'
import Apple from './Apple'
import Google from './Google'
import Roku from './Roku'

const components = {
  amazon: Amazon,
  apple: Apple,
  google: Google,
  roku: Roku,
}

type AppStoreKind = keyof typeof components

type AppStoreProps = {
  kind: AppStoreKind
} & Record<string, unknown>

const AppStore = ({ kind, ...restProps }: AppStoreProps) => {
  const { t } = useTranslation('@mc/next')

  const Component = components[kind]
  const altTexts: Record<AppStoreKind, string> = {
    amazon: t('store.amazon'),
    apple: t('store.apple'),
    google: t('store.google'),
    roku: t('store.roku'),
  }
  const altText = altTexts[kind]

  return (
    <>
      <span className='mc-sr-only'>{altText}</span>
      <Component {...restProps} />
    </>
  )
}

export default AppStore
